import { a as daysBetween } from './index3.js';
import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Phobs - New Version**
 *
 * @exports bs_376
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  /**
     * @memberOf module:bs_376
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const language = thn.parseUrlParameter('ibelang') || document.querySelector('input[name=lang]')?.value || document.querySelector('.header__lang [aria-current=page]')?.textContent?.toLowerCase();

      if (language && ctx.langs.test(language)) {
        resolve(language);
        return;
      }

      reject('no_language');
    });
  };

  /**
   * @memberOf module:bs_376
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // Final URL
    // https://secure.phobs.net/book.php?page=availability&companyid=310&hotelid=1464&checkin=2025-06-22&checkout=2025-06-24&channelid=afe757c4eb0aae9da4df5593d0c0a965&rateid=462779&ibecurrency=EUR&rate=462779&crcid=37706c5082ad049809e3ee79f7219aa3&model_hpa=ORGANIC
    // URL found in google travel
    // http://secure.phobs.net/webservice/googlehpa/booking.php?hid=1464&checkin=2025-06-22&nights=2&currency=EUR&lang=en
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/booking|book/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    const hotelID = url.searchParams.get('hotelid');

    url.search = '';
    url.pathname = '/webservice/googlehpa/booking.php';
    url.searchParams.set('hid', hotelID);
    url.searchParams.set('checkin', '[date_begin]');
    url.searchParams.set('nights', daysBetween(ctx.data.dateBegin, ctx.data.dateEnd));
    url.searchParams.set('currency', '[currency]');
    url.searchParams.set('lang', '[language]');

    ctx.newUrl = url.toString();
    return ctx;
  };

  /**
     * @memberOf module:bs_376
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = thn.debounce(function () {
    thn.languageCheck();
    thn.pageCheck();
  }, 800);

  /**
     * @memberOf module:bs_376
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {
    return false;
  };

  /**
    * @memberOf module:bs_376
    * @see {@link prestart}
    *
    * @param {object} ctx - The context object.
    */
  engine.boot = function boot() {
    const container = document.documentElement;

    if (container) {
      const debouncedRefresh = thn.debounce(thn.pageCheck, 600);

      const pageUpdate = function updatePage(mutations) {
        const validMutationsCalendar = [...mutations].map((mutation) => ((mutation?.type === 'childList') && mutation?.target?.firstElementChild?.className?.match?.(/page page--2/))).filter((mapResult) => !thn.empty(mapResult));
        if (validMutationsCalendar) {
          debouncedRefresh();
        }
      };

      thn.observeDom(container, pageUpdate, {
        childList: true,
        subtree: true,
        attributes: false,
      });

      thn.shutdown(() => {
        debouncedRefresh.cancel();
        thn.stopObserveDom(container, pageUpdate);
      });
    }

  };

  /**
  * @memberOf module:bs_376
  * @this thn.widgets.price
  * @see {@link Price#set_data}
  *
  * @param {object} ctx - The context object.
  */
  engine.priceParseData = function priceParseData(ctx) {
    const widgetData = {};
    const usersWant2PeopleOrMore = [1049152].includes(thn.data.accountUserId);
    let roomInfo = [];

    // Dates
    let nights;
    const dateBegin = thn.parseUrlParameter('checkin').replace(/-/g, '/');
    const dateEnd = thn.parseUrlParameter('checkout').replace(/-/g, '/');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd);
    }

    // Guests, Adults & Children
    if (usersWant2PeopleOrMore) {
      roomInfo = [...document.querySelectorAll('.unit:not(.unit--hidden) .unit__rate-plan-price-container')]
        .filter((el) => thn.parseNumber(el?.nextSibling?.nextSibling?.textContent) !== 1)
        .map((el) => {
          const adults = thn.parseNumber(el?.nextSibling?.nextSibling?.textContent);
          const price = thn.parseNumber(el?.querySelector('.unit__rate-plan-price')?.textContent);
          const currency = thn.parseCurrency(el?.querySelector('span')?.textContent);
          return { adults, price, currency };
        });
    }

    if (roomInfo.length === 0) {
      roomInfo = [...document.querySelectorAll('.unit:not(.unit--hidden) .unit__rate-plan-price-container')].map((el) => {
        const adults = thn.parseNumber(el?.nextSibling?.nextSibling?.textContent);
        const price = thn.parseNumber(el?.querySelector('.unit__rate-plan-price')?.textContent);
        const currency = thn.parseCurrency(el?.querySelector('span')?.textContent);
        return { adults, price, currency };
      });
    }
    roomInfo.sort((a, b) => a.price - b.price);

    const adults = thn.parseNumber(document.querySelectorAll('.unit.mg-top-4:not(.unit--hidden) .card.unit-card')[0]?.querySelectorAll('.fa-male').length) || 0;
    const children = thn.parseNumber(document.querySelectorAll('.unit.mg-top-4:not(.unit--hidden) .card.unit-card')[0]?.querySelectorAll('.fa-child').length) || 0;

    widgetData.adults = adults > roomInfo[0].adults ? roomInfo[0].adults : adults;
    widgetData.children = (adults + children) > roomInfo[0].adults ? ((roomInfo[0].adults - adults) > 0 ? (roomInfo[0].adults - adults) : 0) : children;
    widgetData.guests = thn.parseNumber(widgetData.adults) + thn.parseNumber(widgetData.children);

    // Prices
    const lowestPrice = roomInfo[0]?.price;

    // Currency
    const currency = roomInfo[0]?.currency;

    // No availability
    const noAvailability = document.querySelector('.info-box .fa-triangle-exclamation');

    if (!thn.empty(lowestPrice) && currency) {
      widgetData.price = lowestPrice / nights;
      widgetData.currency = currency;
      widgetData.roomDetails = engine._roomDetailsParseData();
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;

  };

  /**
    *
    * @memberOf module:bs_376
    *
    */
  engine._roomDetailsParseData = function roomDetailsParseData() {
    const roomsInfo = document.querySelectorAll('.card.unit-card');
    const roomDetailsArray = [];
    roomsInfo?.forEach((room) => {
      const roomName = room.querySelector('.card__title-inner span')?.textContent;
      const roomAdults = room.querySelectorAll('.fa-male').length;
      const roomChildren = room.querySelectorAll('.fa-child').length;
      const roomType = getRoomType(roomName);
      const roomData = {
        id: '',
        name: roomName,
        adults: roomAdults,
        children: roomChildren,
        type: roomType,
        prices: [],
      };
      const ratesInfo = room.querySelectorAll('.unit__rate-plan');
      ratesInfo?.forEach((rate) => {
        const rateName = rate.querySelector('.unit__rate-plan-title')?.textContent;
        const nights = thn.parseNumber(rate.querySelector('.unit__rate-plan-select-info')?.textContent.split(',')[1]);
        const price = thn.parseNumber(rate.querySelector('.unit__rate-plan-price')?.textContent);
        let pricePerNight;
        if (price && nights) {
          pricePerNight = (Math.round(price / nights) * 100) / 100;
        }
        const rateInfo = {
          id: '',
          name: rateName,
          totalNight: pricePerNight,
          breakfast: !!rateName.match(/breakfast|śniadaniem|frühstück|doručkom|colazione|zajtrkom/i),
          refundable: true, // We can always cancel our reservation 4 days before check-in.
        };
        roomData.prices.push(rateInfo);
      });
      roomDetailsArray.push(roomData);
    });
    return roomDetailsArray;
  };

  /**
  * @memberOf module:bs_376
  * @this thn.widgets.booking
  * @see {@link Booking#set_data}
  *
  * @param {object} ctx - The context object.
  */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    // bookingId
    const bookingId = document.querySelector('.reservation-code span')?.textContent || thn.parseUrlParameter('rescode');

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }
    widgetData.bookingId = bookingId;

    // Dates
    widgetData.dateBegin = thn.parseUrlParameter('checkin')?.replace(/-/g, '/');
    widgetData.dateEnd = thn.parseUrlParameter('checkout')?.replace(/-/g, '/');

    // Prices & currency
    const priceSel = document.querySelector('#SummaryGrandTotalValue');
    widgetData.price = thn.parseNumber(priceSel?.textContent);
    widgetData.currency = thn.parseCurrency(priceSel?.textContent);

    return widgetData;
  };

  /**
         * @memberOf module:bs_382
         * @this thn.widgets.price
         * @see {@link Price#get_promocode}
         *
         * @param {object} ctx - The context object.
         */
  engine.getPromocode = function getPromocode(ctx) {
    ctx.promocode = thn.dataLayerHelper.get('promocode') || '';
    return ctx.promocode;
  };

  return engine;
}

export { factory };
